import { Checkbox } from "./ui/checkbox";

export const RememberDevice = ({ value, onChange, disabled = false, idPrefix }) => (
  <div className="space-y-3 min-w-0" data-testid={`${idPrefix}-remember-control`}>
    <div className="flex items-start gap-3">
      <Checkbox
        id={`${idPrefix}-remember`}
        checked={value !== null}
        onCheckedChange={(checked) => onChange(checked === true ? 30 : null)}
        disabled={disabled}
        className="mt-0.5 border-zinc-500 data-[state=checked]:bg-[#F5A623] data-[state=checked]:text-black focus-visible:ring-[#F5A623]"
        data-testid={`${idPrefix}-remember-checkbox`}
      />
      <label htmlFor={`${idPrefix}-remember`} className="text-sm text-zinc-300 cursor-pointer leading-5">
        Να θυμάσαι αυτή τη συσκευή
      </label>
    </div>
    <div className="flex items-center gap-3">
      <label htmlFor={`${idPrefix}-remember-days`} className="text-xs text-zinc-400 shrink-0">Διάρκεια</label>
      <select
        id={`${idPrefix}-remember-days`}
        value={value ?? 30}
        onChange={(event) => onChange(Number(event.target.value))}
        disabled={disabled || value === null}
        className="w-full min-w-0 h-10 rounded-lg bg-[#161616] border border-[#333] px-3 py-2 leading-5 text-sm text-white focus:outline-none focus:border-[#F5A623] disabled:opacity-40 transition-colors"
        data-testid={`${idPrefix}-remember-days`}
      >
        {[30, 60, 90].map((days) => (
          <option key={days} value={days} data-testid={`${idPrefix}-remember-option-${days}`}>{`${days} ημέρες`}</option>
        ))}
      </select>
    </div>
    <p className="text-xs text-zinc-400 leading-5" data-testid={`${idPrefix}-remember-status`}>
      {value === null ? "Σύνδεση για 24 ώρες." : `Σύνδεση για ${value} ημέρες. Μόνο σε προσωπική συσκευή.`}
    </p>
  </div>
);